const getExplicitGeometryHash = (value) => String(
  value?.geometry_hash || value?.geometryHash || ''
).trim()

export const hasLandGeometryChanged = (previousLand, nextLand) => {
  const previousHash = getExplicitGeometryHash(previousLand)
  const nextHash = getExplicitGeometryHash(nextLand)

  return Boolean(previousHash && nextHash && previousHash !== nextHash)
}

export const doesHdAccessMatchGeometry = (access, geometryHash) => {
  const expectedHash = String(geometryHash || '').trim()
  if (!expectedHash) {
    return true
  }

  return getExplicitGeometryHash(access) === expectedHash
}

export const omitLandCacheEntries = (entries, landId) => {
  const prefix = `${encodeURIComponent(landId || '')}:`

  return Object.fromEntries(
    Object.entries(entries || {}).filter(([key]) => !key.startsWith(prefix))
  )
}
